var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"100%","height":"100%"}},[(_vm.points)?_c('polygon',{attrs:{"fill":_vm.fill,"stroke":_vm.stroke,"stroke-width":_vm.strokeWidth,"points":_vm.points}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }